import { get } from 'lodash';
import React from 'react';
import { PLATZHALTER_TEXT, VORHABENS_ART } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { checkIfAnyPartnerHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import AssoziiertepartnerAntragGlobal, { getFormStrucAssoziertepartnerAntragGlobal } from './content/AssoziiertepartnerAntragGlobal';
import VerbundpartnerAntragGlobal, { getFormStrucVerbundpartnerAntragGlobal } from './content/VerbundpartnerAntragGlobal';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureAntragVerbundpartnerGlobal = (application: any, readOnly: boolean) => {
	let treeNodes: TreeNodeType[] = [];

	const hasCommentAnyPartner = checkIfAnyPartnerHasComment(readOnly, application);
	const hasAnyAssoPartnerHasComment = checkIfAnyPartnerHasComment(readOnly, application, true);

	if (get(application, P.Allgemein_Vorhabensart.path, '') === VORHABENS_ART.Verbundvorhaben) {
		treeNodes = [
			{
				label: 'Projektpartner',
				content: <ApplicationHeading title='Projektpartner' description={PLATZHALTER_TEXT} />,
				hasComment: hasCommentAnyPartner || hasAnyAssoPartnerHasComment,
				children: [
					{
						label: 'Verbundpartner',
						content: <VerbundpartnerAntragGlobal hasComment={hasCommentAnyPartner} />,
						formStruc: getFormStrucVerbundpartnerAntragGlobal(application, readOnly),
						hasComment: hasCommentAnyPartner,
					},
					{
						label: 'Assoziierte Partner',
						content: <AssoziiertepartnerAntragGlobal hasComment={hasAnyAssoPartnerHasComment} />,
						hasComment: hasAnyAssoPartnerHasComment,
						formStruc: getFormStrucAssoziertepartnerAntragGlobal(application),
					},
				],
			},
		];
	}
	return treeNodes;
};
